import { Directive, HostBinding, OnDestroy, OnInit, inject } from '@angular/core';
import { Subscription } from 'rxjs';

import { UserAccountService } from '../services/user-account/user-account.service';

@Directive({
  selector: '[appRestrictedAccessWarning]',
  standalone: true,
})
export class RestrictedAccessWarningDirective implements OnInit, OnDestroy {
  @HostBinding('style.display') display: string | null = null;

  private readonly userAccountService = inject(UserAccountService);
  private profileSub?: Subscription;

  ngOnInit(): void {
    this.applyVisibility(this.readFromStorage());

    this.profileSub = this.userAccountService.getUserProfile().subscribe({
      next: (response) => {
        const show =
          response?.data?.show_restricted_access_warning !== false;
        this.applyVisibility(show);
        this.persistToLoginDetails(show);
      },
      error: () => {
        // Keep the value already applied from localStorage / default.
      },
    });
  }

  ngOnDestroy(): void {
    this.profileSub?.unsubscribe();
  }

  private applyVisibility(show: boolean): void {
    this.display = show ? null : 'none';
  }

  private readFromStorage(): boolean {
    try {
      const raw = localStorage.getItem('USER_PORTAL');
      if (!raw) {
        return true;
      }
      const portal = JSON.parse(raw);
      return portal?.loginDetails?.show_restricted_access_warning !== false;
    } catch {
      return true;
    }
  }

  private persistToLoginDetails(show: boolean): void {
    try {
      const raw = localStorage.getItem('USER_PORTAL');
      if (!raw) {
        return;
      }
      const portal = JSON.parse(raw);
      if (!portal.loginDetails) {
        portal.loginDetails = {};
      }
      portal.loginDetails.show_restricted_access_warning = show;
      localStorage.setItem('USER_PORTAL', JSON.stringify(portal));
    } catch {
      // Ignore storage write failures.
    }
  }
}
